module.exports = __webpack_public_path__ + "img/0.82ad3e74.jpg";